import { FIELDS } from './constants';

const defaultFields = [  
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Name',
    field: FIELDS.NAME,
    title: ' Name',
    label: 'Name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SyncToken',
    field: FIELDS.SYNC_TOKEN,
    title: ' Sync Token',
    label: 'SyncToken',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AcctNum',
    field: FIELDS.ACCT_NUM,
    title: ' Acct Num',
    label: 'AcctNum',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CurrencyRefName',
    field: FIELDS.CURRENCY_REF_NAME,
    title: ' Currency Ref Name',
    label: 'CurrencyRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CurrencyRefValue',
    field: FIELDS.CURRENCY_REF_VALUE,
    title: ' Currency Ref Value',
    label: 'CurrencyRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SubAccount',
    field: FIELDS.SUB_ACCOUNT,
    title: ' Sub Account',
    label: 'SubAccount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Classification',
    field: FIELDS.CLASSIFICATION,
    title: ' Classification',
    label: 'Classification',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'FullyQualifiedName',
    field: FIELDS.FULLY_QUALIFIED_NAME,
    title: ' Fully Qualified Name',
    label: 'FullyQualifiedName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TxnLocationType',
    field: FIELDS.TXN_LOCATION_TYPE,
    title: ' Txn Location Type',
    label: 'TxnLocationType',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AccountType',
    field: FIELDS.ACCOUNT_TYPE,
    title: ' Account Type',
    label: 'AccountType',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CurrentBalanceWithSubAccounts',
    field: FIELDS.CURRENT_BALANCE_WITH_SUB_ACCOUNTS,
    title: ' Current Balance With Sub Accounts',
    label: 'CurrentBalanceWithSubAccounts',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AccountAlias',
    field: FIELDS.ACCOUNT_ALIAS,
    title: ' Account Alias',
    label: 'AccountAlias',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AccountSubType',
    field: FIELDS.ACCOUNT_SUB_TYPE,
    title: ' Account Sub Type',
    label: 'AccountSubType',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CurrentBalance',
    field: FIELDS.CURRENT_BALANCE,
    title: ' Current Balance',
    label: 'CurrentBalance',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    title: ' ',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
